import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ChartWheel from "../components/ChartWheel";
import { api } from "../lib/api";
import { useContent } from "../lib/content";

const READING_LABELS = {
  "Tríada": "El Faro Interno",
  "Personal": "Las Herramientas del Navegante",
  "Completo": "La Travesía Completa",
  "Revolución Solar": "Revolución Solar",
};

export default function Lectura() {
  const { orderId } = useParams();
  const { t } = useContent();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/orders/${orderId}`)
      .then(({ data }) => setOrder(data))
      .catch((e) => setError(e?.response?.data?.detail || "No se encontró el pedido"));
  }, [orderId]);

  if (error) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <section className="pt-40 pb-20 max-w-2xl mx-auto px-6 text-center">
          <h1 className="font-display text-4xl text-white font-light">{error}</h1>
        </section>
        <Footer />
      </div>
    );
  }
  if (!order) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <section className="pt-40 max-w-xl mx-auto px-6 text-center">
          <div className="text-[#C9A25E] text-4xl animate-pulse">✦</div>
        </section>
      </div>
    );
  }

  return (
    <div data-testid="lectura-page" className="min-h-screen">
      <Navbar />
      <section className="pt-32 pb-12 max-w-4xl mx-auto px-6">
        <p className="overline mb-3">{t("lectura_overline")}</p>
        <h1 className="font-display text-5xl text-white font-light tracking-tighter mb-2">
          Gracias, {order.name} ✦
        </h1>
        <p className="text-zinc-400 mb-12">
          Recibimos tu pedido <strong className="text-white">{order.plan === "session" ? "Reporte + Sesión 1:1" : "Solo Reporte (PDF + DOCX)"}</strong> · <span className="text-[#C9A25E]">{READING_LABELS[order.reading_type] || order.reading_type}</span>
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {order.chart && <ChartWheel chart={order.chart} size={460} />}
          <div>
            {order.status === "delivered" ? (
              <div className="card-feature highlight">
                <p className="overline mb-3">Entregado</p>
                <h2 className="font-display text-3xl text-white mb-4">Tu reporte está listo</h2>
                <p className="text-zinc-300 leading-relaxed mb-4 whitespace-pre-wrap">{order.delivery_message}</p>
                {order.delivery_pdf_url && (
                  <a href={order.delivery_pdf_url} target="_blank" rel="noreferrer" className="btn-lilac">
                    Descargar PDF ✦
                  </a>
                )}
              </div>
            ) : (
              <div className="card-feature">
                <p className="overline mb-3">En proceso</p>
                <h2 className="font-display text-3xl text-white mb-4">Estoy preparando tu reporte</h2>
                <p className="text-zinc-400 leading-relaxed mb-3">
                  Recibirás tu PDF personalizado en este mismo correo (<span className="text-white">{order.email}</span>) en los próximos 3 a 5 días.
                </p>
                <p className="text-zinc-500 text-sm">
                  Tipo de lectura: <span className="text-[#C9A25E]">{READING_LABELS[order.reading_type] || order.reading_type}</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
